import type { TextField } from '@payloadcms/plugin-form-builder/types';
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form';

import { useTranslations } from 'next-intl';

import { Label } from '@/components/ui/label';
import { Textarea as TextAreaComponent } from '@/components/ui/textarea';
import { FormFieldError } from '@/payload/blocks/form/components/error';
import { cn } from '@/utils/cn';

type TextareaProps = TextField & {
  errors: Partial<FieldErrorsImpl<{ [x: string]: unknown }>>;
  register: UseFormRegister<FieldValues>;
  rows?: number;
};

export const Textarea: React.FC<TextareaProps> = ({
  required: requiredFromProps,
  defaultValue,
  register,
  errors,
  label,
  name,
  rows,
}) => {
  const t = useTranslations('forms');

  return (
    <div className="w-full space-y-2">
      <Label htmlFor={name}>{label}</Label>

      <TextAreaComponent
        aria-describedby={errors[name] ? `${name}-error` : undefined}
        aria-invalid={Boolean(errors[name])}
        className={cn('min-h-12 w-full', errors[name] && 'border-red-300')}
        defaultValue={defaultValue}
        id={name}
        required={Boolean(requiredFromProps)}
        rows={rows || 3}
        {...register(name, {
          minLength: {
            message: t('minLength10'),
            value: 10,
          },
          required: {
            message: t('required'),
            value: requiredFromProps || false,
          },
        })}
      />

      {errors[name] && (
        <FormFieldError id={`${name}-error`} message={String(errors[name]?.message || t('required'))} title={label} />
      )}
    </div>
  );
};
